import React, { useMemo } from 'react';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import {
    PhantomWalletAdapter,
    SolflareWalletAdapter,
    TorusWalletAdapter,
    LedgerWalletAdapter,
} from '@solana/wallet-adapter-wallets';
import { clusterApiUrl } from '@solana/web3.js';

// Import wallet adapter CSS
import '@solana/wallet-adapter-react-ui/styles.css';

/**
 * WalletContextProvider - Provides Solana wallet connection functionality
 *
 * This context wraps the application and provides:
 * - Connection to Solana blockchain (devnet by default)
 * - Support for multiple wallet adapters (Phantom, Solflare, Torus, Ledger)
 * - Wallet modal UI for connecting/disconnecting
 *
 * Can be easily modified or disabled without affecting other features.
 */
export function WalletContextProvider({ children }) {
    // Configure which network to connect to (devnet for testing, mainnet-beta for production)
    const network = clusterApiUrl('devnet');

    // Configure supported wallet adapters
    // Add or remove wallets here as needed
    const wallets = useMemo(
        () => [
            new PhantomWalletAdapter(),
            new SolflareWalletAdapter(),
            new TorusWalletAdapter(),
            new LedgerWalletAdapter(),
        ],
        []
    );

    return (
        <ConnectionProvider endpoint={network}>
            <WalletProvider wallets={wallets} autoConnect>
                <WalletModalProvider>
                    {children}
                </WalletModalProvider>
            </WalletProvider>
        </ConnectionProvider>
    );
}
